import React, { useContext } from 'react';
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { cx } from "../../../lib/theming/Emotion";
import * as CDS from "../CalendarDateShape";
import { styles } from "../DayCellView.styles";
export function DayCellView(props) {
  var _cx;

  var date = props.date,
      minDate = props.minDate,
      maxDate = props.maxDate,
      today = props.today,
      value = props.value,
      isWeekend = props.isWeekend,
      onDateClick = props.onDateClick;
  var theme = useContext(ThemeContext);

  var handleClick = function handleClick() {
    var _props$date = props.date,
        date = _props$date.date,
        month = _props$date.month,
        year = _props$date.year;
    onDateClick == null ? void 0 : onDateClick({
      date: date,
      month: month,
      year: year
    });
  };

  return /*#__PURE__*/React.createElement("button", {
    tabIndex: -1,
    disabled: !CDS.isBetween(date, minDate, maxDate),
    className: cx((_cx = {}, _cx[styles.cell(theme)] = true, _cx[styles.today(theme)] = Boolean(today && CDS.isEqual(date, today)), _cx[styles.selected(theme)] = Boolean(value && CDS.isEqual(date, value)), _cx[styles.weekend(theme)] = Boolean(isWeekend), _cx)),
    onClick: handleClick
  }, date.date);
}